import axios from "axios";
import Config from "../../utils/Config";

class PromotionService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("dbx_aff_tkn")}`,
      },
    };
  }

  async applyPromotion(payload) {
    try {
      const response = await axios.post(
        `${Config.devBackendDomain}affiliate/apply/deal`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message:
          response.data?.data?.reason || "Promotion applied successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response.data.message || "Something went wrong",
      };
    }
  }

  async getAllAppliedDeals() {
    try{
      const response = await axios.get(
        `${Config.devBackendDomain}affiliate/applied/deals`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "All applied deals fetched successfully",
      };
    }catch(error){
      return {
        status: false,
        data: null,
        message: error.response.data.message || "Something went wrong",
      }
    }
  }

  async removePromotion(slug){
    try{
      const response = await axios.delete(
        `${Config.devBackendDomain}affiliate/remove/applied/deal/${slug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.message || "Promotion removed successfully",
      }
    }catch(error){
      return {
        status: false,
        data: null,
        message: error.response.data.message || "Something went wrong",
      }
    }
  } 
}

const promotionService = new PromotionService();
export default promotionService;
